import { useState } from "react";
import {
  mockDataForLicense,
  mockIgnitionModule,
  mockMakerLicenses,
} from "./Licenses.mocks";

export const useDemo = () => {
  const [restrictedView] = useState(false);

  return {
    restrictedView,
    mockMakerLicenses,
    mockDataForLicense,
    mockIgnitionModule,
  };
};
